module.exports = __webpack_public_path__ + "img/horizontal_7_6_8011.2704b5b2.png";